import { AppThunkAction } from '../../reducers';
import { Consultorio } from '../../../models/Entities/Turnero';
import { ErrorType } from '../../../models/HttpError';

// services
import * as Services from '../../../services/Turnero-Consultorios.Services';

// actions
import * as ActionEvents from '../../actions/Turnero-Consultorios.Actions';
import {
    TurneroConsultoriosCreateFailureAction,
    TurneroConsultoriosCreateRequestAction,
    TurneroConsultoriosCreateSuccessAction,
    TurneroConsultoriosDeleteFailureAction,
    TurneroConsultoriosDeleteRequestAction,
    TurneroConsultoriosDeleteSuccessAction,
    TurneroConsultoriosGetAllFailureAction,
    TurneroConsultoriosGetAllRequestAction,
    TurneroConsultoriosGetAllSuccessAction,
    TurneroConsultoriosGetDisponiblesDoctorFailureAction,
    TurneroConsultoriosGetDisponiblesDoctorRequestAction,
    TurneroConsultoriosGetDisponiblesDoctorSuccessAction,
    TurneroConsultoriosGetDisponiblesFailureAction,
    TurneroConsultoriosGetDisponiblesRequestAction,
    TurneroConsultoriosGetDisponiblesSuccessAction,
    TurneroConsultoriosUpdateEstadoFailureAction,
    TurneroConsultoriosUpdateEstadoRequestAction,
    TurneroConsultoriosUpdateEstadoSuccessAction,
    TurneroConsultoriosUpdateFailureAction,
    TurneroConsultoriosUpdateRequestAction,
    TurneroConsultoriosUpdateSuccessAction
} from '../../actions/Turnero-Consultorios.Actions';

type KnownAction =
    | TurneroConsultoriosGetAllRequestAction
    | TurneroConsultoriosGetAllSuccessAction
    | TurneroConsultoriosGetAllFailureAction
    | TurneroConsultoriosCreateRequestAction
    | TurneroConsultoriosCreateSuccessAction
    | TurneroConsultoriosCreateFailureAction
    | TurneroConsultoriosGetDisponiblesRequestAction
    | TurneroConsultoriosGetDisponiblesSuccessAction
    | TurneroConsultoriosGetDisponiblesFailureAction
    | TurneroConsultoriosGetDisponiblesDoctorRequestAction
    | TurneroConsultoriosGetDisponiblesDoctorSuccessAction
    | TurneroConsultoriosGetDisponiblesDoctorFailureAction
    | TurneroConsultoriosUpdateRequestAction
    | TurneroConsultoriosUpdateSuccessAction
    | TurneroConsultoriosUpdateFailureAction
    | TurneroConsultoriosDeleteRequestAction
    | TurneroConsultoriosDeleteSuccessAction
    | TurneroConsultoriosDeleteFailureAction
    | TurneroConsultoriosUpdateEstadoRequestAction
    | TurneroConsultoriosUpdateEstadoSuccessAction
    | TurneroConsultoriosUpdateEstadoFailureAction;

export const actionCreators = {
    GetConsultorios: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_CONSULTORIOS_GET_ALL_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_CONSULTORIOS_GET_ALL_REQUEST
        });

        Services.GetConsultorios(token)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_GET_ALL_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_GET_ALL_FAILURE,
                    error
                });
            });
    },
    CreateConsultorio: (consultorio: Consultorio): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_CONSULTORIOS_CREATE_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_CONSULTORIOS_CREATE_REQUEST,
            payload: consultorio
        });

        Services.CreateConsultorio(token, consultorio)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_CREATE_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_CREATE_FAILURE,
                    error
                });
            });
    },
    GetConsultoriosDisponibles: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_REQUEST
        });

        Services.GetConsultoriosDisponibles(token)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_FAILURE,
                    error
                });
            });
    },
    GetConsultoriosDisponiblesDoctor: (doctorId: string, medicoId?: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_FAILURE,
                doctorId,
                medicoId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_REQUEST,
            doctorId,
            medicoId
        });

        Services.GetConsultoriosDisponiblesPorDoctor(token, doctorId, medicoId)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_SUCCESS,
                    doctorId,
                    medicoId,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_FAILURE,
                    doctorId,
                    medicoId,
                    error
                });
            });
    },
    UpdateConsultorio: (id: number, consultorio: Consultorio): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_FAILURE,
                id,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_REQUEST,
            id,
            consultorio
        });

        Services.UpdateConsultorio(token, id, consultorio)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_SUCCESS,
                    id,
                    consultorio,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_FAILURE,
                    id,
                    error
                });
            });
    },
    DeleteConsultorio: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_CONSULTORIOS_DELETE_FAILURE,
                id,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_CONSULTORIOS_DELETE_REQUEST,
            id
        });

        Services.DeleteConsultorio(token, id)
            .then(() => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_DELETE_SUCCESS,
                    payload: id
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_DELETE_FAILURE,
                    id,
                    error
                });
            });
    },
    UpdateEstadoConsultorio: (id: number, estado: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_ESTADO_FAILURE,
                id,
                estado,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_ESTADO_REQUEST,
            id,
            estado
        });

        Services.UpdateEstadoConsultorio(token, id, estado)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_ESTADO_SUCCESS,
                    id,
                    estado,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_CONSULTORIOS_UPDATE_ESTADO_FAILURE,
                    id,
                    estado,
                    error
                });
            });
    }
};
